export const LABELS = {
    0: "In behandeling",
    1: "Laat",
    2: "Voltooid",
    3: "Geannuleerd",
    4: "Handmatige",
    5: "Gepland",
    6: "Afgerond",
}

export const STATUS = {
    0: "warning",
    1: "orange",
    2: "success",
    3: "error",
    4: "grey",
    5: "info",
    6: "grey",
};
export const STEP_LABELS ={
    0: "Bezig",
    1: "Wachten",
    2: "Afgerond",
    3: "Afgesloten",
    4: "Niet gestart",
}

export const LABEL_AI = {
    0: "Zeer potentieel",
    1: "Potentieel",
    2: "Lage potentie",
    3: "Geen interesse",
    4: "Gekwalificeerd",
    5: "Bijna gesloten",
    6: "Klaar om te sluiten",
}

export const STATUS_AI = {
    0: "success",
    1: "info",
    2: "warning",
    3: "grey",
    4: "success",
    5: "info",
    6: "success",
}